import { toast } from "@/components/ui/use-toast";

export const cleanApiUrl = (url: string | null | undefined): string => {
  if (!url) return "";

  let cleaned = url;

  cleaned = cleaned.replace(/^["']+|["']+$/g, "");

  cleaned = cleaned.replace(/\\\//g, "/");

  cleaned = cleaned.replace(/\\/g, "");

  return cleaned;
};

export const ensurePdfExtension = (url: string | null | undefined): string => {
  if (!url) return "";

  const cleaned = cleanApiUrl(url);

  // If URL already ends with .pdf, return it
  if (cleaned.endsWith(".pdf")) {
    return cleaned;
  }

  // If URL ends with /bank_slip, add .pdf
  if (cleaned.endsWith("/bank_slip")) {
    return `${cleaned}.pdf`;
  }

  // Otherwise, just add .pdf at the end
  return `${cleaned}.pdf`;
};

export const sanitizeUrl = (url: string | null | undefined): string => {
  if (!url) return "";

  // First, clean the URL from API issues
  let cleaned = cleanApiUrl(url);

  // Remove duplicate slashes except after protocol (https://)
  cleaned = cleaned.replace(/([^:]\/)\/+/g, "$1");

  // Ensure URL starts with https://
  if (!cleaned.startsWith("http://") && !cleaned.startsWith("https://")) {
    return `https://${cleaned}`;
  }

  return cleaned;
};

/**
 * Open URL in new tab with fallback for popup blockers
 */
export const openInNewTab = (
  url: string | null | undefined,
  fallbackMessage?: string,
) => {
  const sanitized = sanitizeUrl(url);

  if (!sanitized) {
    console.error("Invalid URL provided");
    if (fallbackMessage) {
      toast({
        title: "URL inválida",
        description: fallbackMessage,
        variant: "destructive",
      });
    }
    return;
  }

  try {
    const newWindow = window.open(sanitized, "_blank", "noopener,noreferrer");

    // Fallback if popup blocked
    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === "undefined"
    ) {
      const link = document.createElement("a");
      link.href = sanitized;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.click();
    }
  } catch (error) {
    console.error("Error opening URL:", error);
    if (fallbackMessage) {
      toast({
        title: "Erro ao abrir link",
        description: fallbackMessage,
        variant: "destructive",
      });
    }
  }
};
